export const BetaEndpoints = {
     advert: "adverts",
     category: "category",
     agent:"agents",
     blog: "blogs",
     banner:"banners",
     user:"users",
     webViews:"web-views",
     subCategory:"sub-category"
}